import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "../../wepcg/sidebar/help_hints";
import "../../wepcg/sidebar/css/wepcg_bar.css"

class ProductDamageBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Return Request (Product Damage)</strong></h1>
            <p>
                This claim type is used for physical damage to the actual item in intact packaging; damage probably occurred in manufacturing. Please upload photos of the damage. Make sure the collection details are correct. Contact person should be aware of the incident so our logistics provider can contact them and arrange details of the actual collection. Please have the goods ready for collection. Please contact our financial claims team in case there is any question or problem.
            </p>
            <p>
                Be informed you will be contacted by TNT team per mail with link to TNT tool (check also spam folder). Please fill in all required data into TNT tool accordingly (weights, dimensions, number of pallets/boxes and requested delivery date), this will help us to speed up return of goods.
            </p>
            <p>
                Claims for product damaged goods must be received by Lenovo no more than fifteen (15) working days after the date of delivery. Please check guideline.
            </p>
            <Help_hints />
        </div>
    }
}

export default ProductDamageBar;